<template>
  <!-- Elements -->
  <div class="z-0">
    <span class="absolute bottom-2/3 right-3/4 swing">
      <img src="@/assets/images/elements/cloud-left.svg">
    </span>

    <span class="absolute z-0 bottom-1/4 left-3/4 swing-reverse">
      <img src="@/assets/images/elements/cloud-right.svg">
    </span>

    <span class="absolute z-0 hidden lg:block top-1/3 left-2/3" v-if="wandElement">
      <img src="@/assets/images/elements/wand.svg">
    </span>
  </div>
</template>

<script>
export default {
  props: {
    wandElement: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style scoped>

@media (min-width: 1024px) {
    .swing {
        -webkit-animation: animateCloud 60s linear infinite;
        -moz-animation: animateCloud 60s linear infinite;
        animation: animateCloud 60s linear infinite;
    }

    .swing-reverse {
        -webkit-animation: animateCloudReverse 60s linear infinite;
        -moz-animation: animateCloudReverse 60s linear infinite;
        animation: animateCloudReverse 60s linear infinite;
    }
}

@-webkit-keyframes animateCloud {
    0% {
        transform: translateX(-100%);
    }
    50% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(-100%);
    }
}

@-moz-keyframes animateCloud {
    0% {
        transform: translateX(-100%);
    }
    50% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(-100%);
    }
}

@keyframes animateCloud {
    0% {
        transform: translateX(-100%);
    }
    50% {
        transform: translateX(100%);
    }
    100% {
        transform: translateX(-100%);
    }
}

@-webkit-keyframes animateCloudReverse {
    0% {
        transform: translateX(100%);
    }
    50% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

@-moz-keyframes animateCloudReverse {
    0% {
        transform: translateX(100%);
    }
    50% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}

@keyframes animateCloudReverse {
    0% {
        transform: translateX(100%);
    }
    50% {
        transform: translateX(-100%);
    }
    100% {
        transform: translateX(100%);
    }
}
</style>
